import React, { useState } from 'react'
import { Business, LeadSubscription, UserWithBusiness } from '@marketing-milk/interfaces'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'
import { Switch, Typography } from '@material-ui/core'
import AssignBusinesses from '../../modals/AssignBusinesses'
import { Delete } from '../../modals/Delete'
import { NestAPI, userService } from '@marketing-milk/frontend'
import { toast } from 'react-toastify'
import axios from 'axios'
import { keyBy } from 'lodash'
export interface BusinessTabProps {
  userBusinesses: Business[] | undefined
  leadSubscriptions: LeadSubscription[] | undefined
  mmUser?: UserWithBusiness
  refetchUser: () => void
  refetchLeadSubscriptions: () => void
}

export function BusinessTab({
  userBusinesses,
  mmUser,
  leadSubscriptions,
  refetchUser,
  refetchLeadSubscriptions,
}: BusinessTabProps) {
  const [deleteModal, setDeleteModal] = useState(false)
  const onSave = () => {
    refetchUser()
    refetchLeadSubscriptions()
  }

  const leadSubscriptionsByBusiness = keyBy(leadSubscriptions || [], 'businessID')

  const onDelete = async (business: Business) => {
    if (mmUser) {
      try {
        await userService.removeUserFromBusiness(mmUser.id, business.id)
        toast.success('Successfully removed business from user')

        refetchUser()
        refetchLeadSubscriptions()
      } catch (e) {
        if (axios.isAxiosError(e) && e.response?.data) {
          e.response.data.errors.forEach(err => {
            toast.error(err.description)
          })
        } else {
          toast.error(`We could not delete your businesses at this time`)
        }
      }
    }
  }

  const onChangeReceiveLeads = async (businessID: number) => {
    if (mmUser) {
      try {
        const currentSubscription = leadSubscriptionsByBusiness[businessID]
        await NestAPI.post(`session/lead-subscriptions/for-user/${mmUser.id}`, {
          businessID,
          receiveLeads: !currentSubscription?.receiveLeads,
        })
        toast.success('Successfully updated lead subscription for business')

        refetchUser()
        refetchLeadSubscriptions()
      } catch (e) {
        if (axios.isAxiosError(e) && e.response?.data) {
          e.response.data.errors.forEach(err => {
            toast.error(err.description)
          })
        } else {
          toast.error(`We could not update your lead subscription at this time`)
        }
      }
    }
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '15px' }}>
        <Typography>All Businesses assigned to this User</Typography>
        <AssignBusinesses mmUser={mmUser} onSave={onSave} />
      </div>
      <TableContainer component={Paper} style={{ maxHeight: 'calc(100vh - 27rem)' }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>
                <Typography>Name</Typography>
              </TableCell>
              <TableCell align="left">
                <Typography>Pod</Typography>
              </TableCell>
              <TableCell align="left">
                <Typography>Receive Leads</Typography>
              </TableCell>
              <TableCell align="right"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {userBusinesses?.map((b, i) => (
              <TableRow key={i}>
                <TableCell component="th" scope="row">
                  <Typography>
                    <a className="link-brand" href={`/admin/business/beta/accounts/edit/${b.id}`}>
                      {b.businessName}
                    </a>
                  </Typography>
                </TableCell>
                <TableCell align="left">
                  <Typography>{b.podName}</Typography>
                </TableCell>
                <TableCell align="left">
                  <Switch
                    className="float-left"
                    onChange={() => onChangeReceiveLeads(b.id)}
                    checked={leadSubscriptionsByBusiness[b.id]?.receiveLeads}
                  />
                </TableCell>
                <TableCell align="right">
                  <Delete
                    title={'Remove business from user?'}
                    body={`Are you sure that you want to remove ${mmUser?.email} from role "${b?.businessName}"?`}
                    onSubmitted={onDelete}
                    item={b}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  )
}
